import React from 'react'
import { WithItems } from 'services/api/entities/catalog/packages/common'
import { WithIdAndName } from 'types/common'
import LocalizedTextField from './LocalizedFields/LocalizedTextField'
import { Box } from '@mui/material'
import LocalizedChip from './LocalizedFields/LocalizedChip'

type Props = {
  option: WithIdAndName & WithItems<WithIdAndName>
  index: number
}
const OptionGroupWithItems: React.FC<Props> = ({ option, index }) => {
  return (
    <Box marginLeft="1.5rem">
      <h4>{`${index + 1}) \n`}Option group</h4>
      <LocalizedTextField record={option} source="name" />
      <Box marginLeft="1.5rem">
        <h4>Options *</h4>
        {option.items.map((item) => (
          <LocalizedChip
            key={`${item.name}_${item.id}`}
            style={{ marginRight: '16px' }}
          >
            {item.name}
          </LocalizedChip>
        ))}
      </Box>
    </Box>
  )
}

export default OptionGroupWithItems
